import { render, staticRenderFns } from "./admin_dashboard.vue?vue&type=template&id=3605feda"
import script from "./admin_dashboard.vue?vue&type=script&lang=js"
export * from "./admin_dashboard.vue?vue&type=script&lang=js"
import style0 from "./admin_dashboard.vue?vue&type=style&index=0&id=3605feda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports